import classNames from 'classnames';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { CSSTransitionGroup } from 'react-transition-group';

import { closeErrorBar } from 'actions/errorBar';
import { toggleDashboardUpgradeModal } from 'actions/videosDashboard';
import { addBodyClass, getCssVarValue, removeBodyClass } from 'utilities/css';

import { showLoomProVideo } from '../../actions/homepage';
import {
  PRO_DASH_FINAL_UPSELL_STRING,
  PRO_DASH_UPSELL_STRING,
} from '../../constants/error-messages';

import './styles.less';

const ERROR_BAR_TRANSITION_DURATION = parseInt(
  getCssVarValue('--errorBarTransitionDuration')
);

const ErrorBar = class extends Component {
  render() {
    const {
      severity,
      message,
      showing,
      onPrimaryAction,
      primaryButtonLabel,
      actionHref,
      inline,
    } = this.props;

    let errorBar = null;

    const errorBarClass = classNames('error-bar', severity, inline && 'inline');

    if (showing) {
      addBodyClass('errorBarIsOpen');
    } else {
      removeBodyClass('errorBarIsOpen');
      addBodyClass('errorBarIsClosing');

      setTimeout(() => {
        removeBodyClass('errorBarIsClosing');
      }, ERROR_BAR_TRANSITION_DURATION);
    }

    if (showing) {
      errorBar = (
        <div className={errorBarClass}>
          <div className="content-wrapper">
            <p>{message}</p>
            <div className="action-container">
              {onPrimaryAction ? (
                <span className="action-button" onClick={onPrimaryAction}>
                  {primaryButtonLabel}
                </span>
              ) : null}
              {actionHref && (
                <a
                  className="action-button"
                  href={actionHref}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {primaryButtonLabel}
                </a>
              )}
              <span className="close" onClick={this.closeHandler}>
                Dismiss
              </span>
            </div>
          </div>
        </div>
      );
    }

    return (
      <CSSTransitionGroup
        transitionName="error-bar"
        transitionEnterTimeout={ERROR_BAR_TRANSITION_DURATION}
        transitionLeaveTimeout={ERROR_BAR_TRANSITION_DURATION}
      >
        {errorBar}
      </CSSTransitionGroup>
    );
  }

  closeHandler = () => {
    const { onCloseCallback, closeErrorBar } = this.props;

    if (onCloseCallback) {
      onCloseCallback();
    }

    closeErrorBar();
  };
};

const mapStateToProps = state => {
  const { severity, message, showing, actionHref, primaryButtonLabel } =
    state.error_bar;

  return { severity, message, showing, actionHref, primaryButtonLabel };
};

const mapDispatchToProps = dispatch => {
  return {
    closeErrorBar: () => dispatch(closeErrorBar()),
    showLoomPro: () => dispatch(showLoomProVideo()),
    toggleDashboardUpgradeModal: action =>
      dispatch(toggleDashboardUpgradeModal(action)),
  };
};

const mergeProps = (stateProps, dispatchProps) => {
  const { message = '' } = stateProps;
  const { closeErrorBar } = dispatchProps;

  let additionalProps = {};

  if (
    message.endsWith(PRO_DASH_UPSELL_STRING) ||
    message === PRO_DASH_FINAL_UPSELL_STRING
  ) {
    additionalProps = {
      onPrimaryAction: dispatchProps.toggleDashboardUpgradeModal,
      onCloseCallback: closeErrorBar,
      primaryButtonLabel: 'Upgrade to Pro',
    };
  }

  return {
    closeErrorBar,
    ...stateProps,
    ...additionalProps,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(ErrorBar);
